Views.add(new class extends AbstractView {

  constructor() {
    super({
      name: 'faq',
      overlay: true
    });
  }

  onActive() {
    Faqs.displayOnView(this._state);
  }

  mainTitle() {
    return Wording.window_title;
  }

  smallTitle() {
    return Faqs.viewTitle || Wording.homepage_subtitle;
  }

  initEventListeners() {

  }

  _htmlBase() {

  }

});
